import { createContext } from 'react';
import { IAppError, ILoggedUser, TFeatureFlags } from 'types';
import { HubConnection } from '@microsoft/signalr';

export interface IAppState {
	appErrors: IAppError[];
	loggedUser: ILoggedUser;
	isLoading: boolean;
	uploadProgress: Nullable<number>;
	notificationsConnection: Nullable<HubConnection>;
	entityNameForHeader: string;
	pathnamesHistory: string[];
	featureFlags: TFeatureFlags;
}

export const initialState: IAppState = {
	appErrors: [],
	loggedUser: { userId: '', user: '', role: '', filePath: '', customers: null, restaurants: null },
	isLoading: false,
	uploadProgress: null,
	notificationsConnection: null,
	entityNameForHeader: '',
	pathnamesHistory: [],
	featureFlags: {},
};

export interface IAppContext extends IAppState {
	// ----- Additional features ----- //
	addAppError(error: IAppError): void;
	removeAppError(errorID: string): void;
	showLoader(): void;
	hideLoader(): void;
	setUploadProgress(progress: number): void;
	setEntityNameForHeader(name: string): void;
	// ----- Additional features ----- //

	// ----- Authorization and everything connected with it ----- //
	logIn(login: string, password: string): Promise<'fail' | 'success'>;
	passwordReset(email: string): Promise<'fail' | 'emailExists'>;
	createNewPassword(
		password: string,
		urlParams: { passwordResetToken: string; email: string },
	): Promise<'fail' | 'newPassIsCreated'>;
	setUserData(): Promise<void>;
	// ----- Authorization and everything connected with it ----- //
}

export const AppContext = createContext<IAppContext>({
	// ----- Additional features ----- //
	addAppError: () => undefined,
	removeAppError: () => undefined,
	showLoader: () => undefined,
	hideLoader: () => undefined,
	setUploadProgress: () => undefined,
	setEntityNameForHeader: () => undefined,
	// ----- Additional features ----- //

	// ----- Authorization and everything connected with it ----- //
	logIn: async () => 'fail',
	passwordReset: async () => 'fail',
	createNewPassword: async () => 'fail',
	setUserData: async () => undefined,
	// ----- Authorization and everything connected with it ----- //
	...initialState,
});
